import React, { createContext, useContext, useEffect, useCallback } from 'react';

const LanguageContext = createContext();

const LANGUAGE = 'en';

export function LanguageProvider({ children }) {
  useEffect(() => {
    localStorage.setItem('babyxchange-language', LANGUAGE);
    document.documentElement.lang = LANGUAGE;
  }, []);

  const setLanguage = useCallback(() => {}, []);
  const toggleLanguage = useCallback(() => {}, []);

  const value = {
    language: LANGUAGE,
    setLanguage,
    toggleLanguage,
    isEnglish: true,
    isFrench: false
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
